// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.49998 17.5C7.49998 17.0398 7.87308 16.6667 8.33332 16.6667H11.6667C12.1269 16.6667 12.5 17.0398 12.5 17.5 12.5 17.9602 12.1269 18.3333 11.6667 18.3333H8.33332C7.87308 18.3333 7.49998 17.9602 7.49998 17.5ZM5.8752 2.54189C6.96916 1.44792 8.45289.833344 9.99998.833344 11.5471.833344 13.0308 1.44792 14.1248 2.54189 15.2187 3.63585 15.8333 5.11958 15.8333 6.66668 15.8333 9.0939 16.4433 10.7032 17.0828 11.7309L17.0927 11.7468C17.3904 12.2253 17.6258 12.6036 17.7845 12.8789 17.864 13.0169 17.9365 13.1498 17.9901 13.2679 18.0169 13.3269 18.0468 13.3991 18.0702 13.4777 18.0896 13.5429 18.1266 13.6823 18.1128 13.8519 18.1034 13.9659 18.0802 14.1607 17.9684 14.3619 17.8566 14.5632 17.7035 14.6858 17.6116 14.754 17.4031 14.9087 17.1635 14.9441 17.0836 14.9559L17.0799 14.9564C16.9571 14.9746 16.8177 14.9836 16.677 14.9891 16.3977 15 16.0109 15 15.5299 15H4.47011C3.98909 15 3.6023 15 3.32292 14.9891 3.1823 14.9836 3.0429 14.9746 2.92006 14.9564L2.91637 14.9559C2.83643 14.9441 2.5969 14.9087 2.38832 14.754 2.29646 14.6858 2.14335 14.5632 2.03156 14.3619 1.91976 14.1607 1.89652 13.9659 1.8872 13.8519 1.87332 13.6823 1.91032 13.5429 1.92975 13.4777 1.95315 13.3991 1.98311 13.3269 2.00988 13.2679 2.06352 13.1498 2.13596 13.0169 2.21548 12.8789 2.37417 12.6036 2.60957 12.2253 2.90734 11.7467L2.91717 11.7309C3.55665 10.7032 4.16665 9.0939 4.16665 6.66668 4.16665 5.11958 4.78123 3.63585 5.8752 2.54189Z"
      clipRule="evenodd"
    />
  </svg>
);
const IconBellFill = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconBellFill;
